import ISupportRepository from '../../2_domain/support/iSupportRepository';
import { Support, SupportCategory } from '../../2_domain/support/support';
import Get from '../../lib/di/get';
import Connection from '../core/connection';
import { GET_CATEGORIES, GET_SUPPORTS } from './supportQuery';

class SupportRepository implements ISupportRepository {
//LINK - id 54
//NOTE - NA
  getAllCategories = async (): Promise<SupportCategory[]> => {
    const connection = Get.find<Connection>('Connection');
    const client = connection.getClient();
    const res = await client.query({
      query: GET_CATEGORIES,
      fetchPolicy: 'cache-first',
    });

    return res.data['querySupportCategories'];
  };

  //LINK - id 55
  //NOTE - NA
  getAllSupportsByCategory = async (
    category: Category,
    pagination: Pagination
  ): Promise<PageResult<Support>> => {
    const connection = Get.find<Connection>('Connection');
    const client = connection.getClient();
    const res = await client.query({
      query: GET_SUPPORTS,
      fetchPolicy: 'cache-first',
      variables: {
        input: {
          category: category,
          pagination: pagination,
        },
      },
    });
    return {
      page: res.data['querySupportListByCategory']['page'],
      list: res.data['querySupportListByCategory']['list'],
    };
  };
}

export default SupportRepository;
